module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAYAAAAvf+5AAAAAOElEQVR4AWPAB0xMTAqMjIwKCClqMDY2/g9UWD/iFCEAKJxACkEaGAgBkGkjQjEoVIhSDMT5IDYAPVg5BoG5Ts8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/img/left-arrow.png
// module id = 221
// module chunks = 0